import { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Loader, LooptijdrenteMessagebar } from 'shared/components';
import { PrimaryOutlineButton } from 'shared/buttons';
import { ConversieButtons } from 'shared/conversie';
import { getParamsFromState } from 'shared/helpers';
import useMedia from 'shared/hooks/useMedia';
import { sync, SYNC } from 'shared/wizard/actions';
import analytics from 'shared/utility/analytics';
import { resultLimit, whiteListUrlParams } from '../config';
import OverviewHeader from './OverviewHeader';
import ResultsList from './ResultsList';
import debounce from 'lodash/debounce';

const Overview = () => {
  let abortController = useRef();
  const { onMobile } = useMedia();
  const dispatch = useDispatch();
  const { app, input, output: { products }, syncing, settings } = useSelector(state => state);
  const { showAll } = input;

  useEffect(() => {
    analytics.send('Overzicht', 'Openen');
    fireAjaxRequest();
  }, [fireAjaxRequest]);

  const fireAjaxRequest = useCallback(data => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();

    dispatch({ type: SYNC, syncing: true, payload: { products: [] } });

    analytics.send('Overzicht', 'Berekenen');

    axios({
      method: 'post',
      url: '/looptijdrente/calculate/overview',
      data: data || input,
      signal: abortController.current.signal,
    })
      .then(({ data }) => {
        sync(dispatch)('label_id', (data[0] || {}).label_id);
        dispatch({ type: SYNC, syncing: false, payload: { errors: {}, products: data } });
      })
      .catch(error => {
        error.response = error.response || {};
        const { errors } = error.response.data || {};
        dispatch({ type: SYNC, syncing: errors ? false : true, payload: errors ? { errors } : {} });
      });
  });

  const debouncedRequest = useRef(debounce(fireAjaxRequest, 750)).current;

  const change = (key, value) => {
    debouncedRequest.cancel();
    sync(dispatch)(key, value);
    debouncedRequest({...input, [key]: value})
  };

  return (
    <>
      <OverviewHeader handleChange={change} />
      {(!onMobile || !input.openForm) && (
        <>
          {!settings.hideProvidersInResult && <LooptijdrenteMessagebar css={{ marginBottom: '32px' }} />}
          {syncing ? <Loader /> : <ResultsList />}
          {products.length > resultLimit && (
            <PrimaryOutlineButton
              size="big"
              css={{ marginTop: '16px' }}
              onClick={() => sync(dispatch)('showAll', !showAll)}
            >
              {showAll ? 'Toon minder producten' : `Toon alle ${products.length} producten`}
            </PrimaryOutlineButton>
          )}
          {!settings.hideProvidersInResult && (
            <ConversieButtons
              css={{ marginTop: '24px' }}
              app={app}
              settings={settings}
              urlLeadFormParams={getParamsFromState(input, whiteListUrlParams)}
              hidePdfButton
            />
          )}
        </>
      )}
    </>
  );
};

export default Overview;
